import { entries } from "../../ServiceDesk/sdServices/local-storage-wrapper-service";
import { LoggingService } from "../../ServiceDesk/sdServices/loggingSvc";

export let localStoragePrefixesToCapture = ["adal.", "msal."];
// @ngInject
export const logLocalStorage = ($window: ng.IWindowService, loggingService: LoggingService) => {
  // Do not log session information within an iframe
  if ($window != $window.top) {
    return;
  }

  let localStorageContents: string[] = [];
  entries($window.localStorage).forEach((value: any, key: any) => {
    for (let i = 0; i < localStoragePrefixesToCapture.length; i++) {
      if (key.startsWith(localStoragePrefixesToCapture[i])) {
        localStorageContents.push(`"${key}" -> "${value}"`);
        continue;
      }
    }
  });

  loggingService.logInfo(`Local storage contents: [${localStorageContents.join("; ")}]`);
};
